import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import TrustAndVerification from './TrustAndVerification';
import EmailChangeConfirmation from './EmailChangeConfirmation';
import Layout from '../../components/Layout';
import { emailVerification } from '../../actions/manageUserVerification';
import messages from '../../locale/jsonMessages';

export default async function action({ store, query, intl }) {
  const title = intl?.formatMessage(messages.trustAndVerification);
  if ('changeEmail' in query && 'confirm' in query && 'email' in query) {
    return {
      title: intl?.formatMessage(messages.changeEmailTitle),
      component: <Layout><EmailChangeConfirmation token={query.confirm} email={query.email} isAuthenticated={store.getState().runtime.isAuthenticated} /></Layout>,
    };
  }
  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    if ('confirm' in query && 'email' in query) {
      const refer = `/user/verification?confirm=${encodeURIComponent(query.confirm)}&email=${encodeURIComponent(query.email)}`;
      return { redirect: `/login?refer=${encodeURIComponent(refer)}` };
    }
    return { redirect: '/login' };
  }

  let userId = store.getState().account.data.userId;

  if ('confirm' in query && 'email' in query) {
    store.dispatch(emailVerification(query.confirm, query.email, userId));
  }

  return {
    title,
    component: <UserLayout><TrustAndVerification title={title} /></UserLayout>,
  };
};
